"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TENANT_STRIPE_UPDATE_CARD = exports.TENANT_STRIPE_UPCOMING_INVOICES_ERROR = exports.TENANT_STRIPE_UPCOMING_INVOICES_SUCCESS = exports.TENANT_STRIPE_UPCOMING_INVOICES_REQUESTED = exports.TENANT_STRIPE_PREVIEW_INVOICE_ERROR = exports.TENANT_STRIPE_PREVIEW_INVOICE_SUCCESS = exports.TENANT_STRIPE_PREVIEW_INVOICE_REQUESTED = exports.TENANT_STRIPE_INVOICES_ERROR = exports.TENANT_STRIPE_INVOICES_SUCCESS = exports.TENANT_STRIPE_INVOICES_REQUESTED = exports.TENANT_STRIPE_CARD_ERROR = exports.TENANT_STRIPE_CARD_SUCCESS = exports.TENANT_STRIPE_CARD_REQUESTED = exports.TENANT_USER_REQUEST_UPDATE_ERROR = exports.TENANT_USER_REQUEST_UPDATE_SUCCESS = exports.TENANT_USER_REQUEST_UPDATE_REQUESTED = exports.TENANT_USER_UPDATE_ERROR = exports.TENANT_USER_UPDATE_SUCCESS = exports.TENANT_USER_UPDATE_REQUESTED = exports.TENANT_USER_REMOVE_ERROR = exports.TENANT_USER_REMOVE_SUCCESS = exports.TENANT_USER_REMOVE_REQUESTED = exports.TENANT_USERS_ADD_ERROR = exports.TENANT_USERS_ADD_SUCCESS = exports.TENANT_USERS_ADD_REQUESTED = exports.TENANT_USER_ERROR = exports.TENANT_USER_SUCCESS = exports.TENANT_USER_REQUESTED = exports.TENANT_USERS_ERROR = exports.TENANT_USERS_SUCCESS = exports.TENANT_USERS_REQUESTED = exports.TENANT_USER_REQUEST_ADD_ERROR = exports.TENANT_USER_REQUEST_ADD_SUCCESS = exports.TENANT_USER_REQUEST_ADD_REQUESTED = exports.TENANT_USER_REQUESTS_ERROR = exports.TENANT_USER_REQUESTS_SUCCESS = exports.TENANT_USER_REQUESTS_REQUESTED = exports.TENANT_UPDATE_ERROR = exports.TENANT_UPDATE_SUCCESS = exports.TENANT_UPDATE_REQUESTED = exports.TENANT_GET_ERROR = exports.TENANT_GET_SUCCESS = exports.TENANT_GET_REQUESTED = exports.TENANT_ADD_ERROR = exports.TENANT_ADD_SUCCESS = exports.TENANT_ADD_REQUESTED = exports.CLOSE_EDIT_TENANT_USER_MODAL = exports.SHOW_EDIT_TENANT_USER_MODAL = exports.CLOSE_ADD_TENANT_USERS_MODAL = exports.SHOW_ADD_TENANT_USERS_MODAL = exports.CLOSE_ADD_TENANT_MODAL = exports.SHOW_ADD_TENANT_MODAL = exports.TENANTS_ERROR = exports.TENANTS_SUCCESS = exports.TENANTS_REQUESTED = void 0;
// Tenants
var TENANTS_REQUESTED = 'TENANTS_REQUESTED';
exports.TENANTS_REQUESTED = TENANTS_REQUESTED;
var TENANTS_SUCCESS = 'TENANTS_SUCCESS';
exports.TENANTS_SUCCESS = TENANTS_SUCCESS;
var TENANTS_ERROR = 'TENANTS_ERROR';
exports.TENANTS_ERROR = TENANTS_ERROR;
var SHOW_ADD_TENANT_MODAL = 'SHOW_ADD_TENANT_MODAL';
exports.SHOW_ADD_TENANT_MODAL = SHOW_ADD_TENANT_MODAL;
var CLOSE_ADD_TENANT_MODAL = 'CLOSE_ADD_TENANT_MODAL';
exports.CLOSE_ADD_TENANT_MODAL = CLOSE_ADD_TENANT_MODAL;
var SHOW_ADD_TENANT_USERS_MODAL = 'SHOW_ADD_TENANT_USERS_MODAL';
exports.SHOW_ADD_TENANT_USERS_MODAL = SHOW_ADD_TENANT_USERS_MODAL;
var CLOSE_ADD_TENANT_USERS_MODAL = 'CLOSE_ADD_TENANT_USERS_MODAL';
exports.CLOSE_ADD_TENANT_USERS_MODAL = CLOSE_ADD_TENANT_USERS_MODAL;
var SHOW_EDIT_TENANT_USER_MODAL = 'SHOW_EDIT_TENANT_USER_MODAL';
exports.SHOW_EDIT_TENANT_USER_MODAL = SHOW_EDIT_TENANT_USER_MODAL;
var CLOSE_EDIT_TENANT_USER_MODAL = 'CLOSE_EDIT_TENANT_USER_MODAL';
exports.CLOSE_EDIT_TENANT_USER_MODAL = CLOSE_EDIT_TENANT_USER_MODAL;
var TENANT_ADD_REQUESTED = 'TENANT_ADD_REQUESTED';
exports.TENANT_ADD_REQUESTED = TENANT_ADD_REQUESTED;
var TENANT_ADD_SUCCESS = 'TENANT_ADD_SUCCESS';
exports.TENANT_ADD_SUCCESS = TENANT_ADD_SUCCESS;
var TENANT_ADD_ERROR = 'TENANT_ADD_ERROR';
exports.TENANT_ADD_ERROR = TENANT_ADD_ERROR;
var TENANT_GET_REQUESTED = 'TENANT_GET_REQUESTED';
exports.TENANT_GET_REQUESTED = TENANT_GET_REQUESTED;
var TENANT_GET_SUCCESS = 'TENANT_GET_SUCCESS';
exports.TENANT_GET_SUCCESS = TENANT_GET_SUCCESS;
var TENANT_GET_ERROR = 'TENANT_GET_ERROR';
exports.TENANT_GET_ERROR = TENANT_GET_ERROR;
var TENANT_UPDATE_REQUESTED = 'TENANT_UPDATE_REQUESTED';
exports.TENANT_UPDATE_REQUESTED = TENANT_UPDATE_REQUESTED;
var TENANT_UPDATE_SUCCESS = 'TENANT_UPDATE_SUCCESS';
exports.TENANT_UPDATE_SUCCESS = TENANT_UPDATE_SUCCESS;
var TENANT_UPDATE_ERROR = 'TENANT_UPDATE_ERROR';
exports.TENANT_UPDATE_ERROR = TENANT_UPDATE_ERROR;
var TENANT_USER_REQUESTS_REQUESTED = 'TENANT_USER_REQUESTS_REQUESTED';
exports.TENANT_USER_REQUESTS_REQUESTED = TENANT_USER_REQUESTS_REQUESTED;
var TENANT_USER_REQUESTS_SUCCESS = 'TENANT_USER_REQUESTS_SUCCESS';
exports.TENANT_USER_REQUESTS_SUCCESS = TENANT_USER_REQUESTS_SUCCESS;
var TENANT_USER_REQUESTS_ERROR = 'TENANT_USER_REQUESTS_ERROR';
exports.TENANT_USER_REQUESTS_ERROR = TENANT_USER_REQUESTS_ERROR;
var TENANT_USER_REQUEST_ADD_REQUESTED = 'TENANT_USER_REQUEST_ADD_REQUESTED';
exports.TENANT_USER_REQUEST_ADD_REQUESTED = TENANT_USER_REQUEST_ADD_REQUESTED;
var TENANT_USER_REQUEST_ADD_SUCCESS = 'TENANT_USER_REQUEST_ADD_SUCCESS';
exports.TENANT_USER_REQUEST_ADD_SUCCESS = TENANT_USER_REQUEST_ADD_SUCCESS;
var TENANT_USER_REQUEST_ADD_ERROR = 'TENANT_USER_REQUEST_ADD_ERROR';
exports.TENANT_USER_REQUEST_ADD_ERROR = TENANT_USER_REQUEST_ADD_ERROR;
var TENANT_USERS_REQUESTED = 'TENANT_USERS_REQUESTED';
exports.TENANT_USERS_REQUESTED = TENANT_USERS_REQUESTED;
var TENANT_USERS_SUCCESS = 'TENANT_USERS_SUCCESS';
exports.TENANT_USERS_SUCCESS = TENANT_USERS_SUCCESS;
var TENANT_USERS_ERROR = 'TENANT_USERS_ERROR';
exports.TENANT_USERS_ERROR = TENANT_USERS_ERROR;
var TENANT_USER_REQUESTED = 'TENANT_USER_REQUESTED';
exports.TENANT_USER_REQUESTED = TENANT_USER_REQUESTED;
var TENANT_USER_SUCCESS = 'TENANT_USER_SUCCESS';
exports.TENANT_USER_SUCCESS = TENANT_USER_SUCCESS;
var TENANT_USER_ERROR = 'TENANT_USER_ERROR';
exports.TENANT_USER_ERROR = TENANT_USER_ERROR;
var TENANT_USERS_ADD_REQUESTED = 'TENANT_USERS_ADD_REQUESTED';
exports.TENANT_USERS_ADD_REQUESTED = TENANT_USERS_ADD_REQUESTED;
var TENANT_USERS_ADD_SUCCESS = 'TENANT_USERS_ADD_SUCCESS';
exports.TENANT_USERS_ADD_SUCCESS = TENANT_USERS_ADD_SUCCESS;
var TENANT_USERS_ADD_ERROR = 'TENANT_USERS_ADD_ERROR';
exports.TENANT_USERS_ADD_ERROR = TENANT_USERS_ADD_ERROR;
var TENANT_USER_REMOVE_REQUESTED = 'TENANT_USER_REMOVE_REQUESTED';
exports.TENANT_USER_REMOVE_REQUESTED = TENANT_USER_REMOVE_REQUESTED;
var TENANT_USER_REMOVE_SUCCESS = 'TENANT_USER_REMOVE_SUCCESS';
exports.TENANT_USER_REMOVE_SUCCESS = TENANT_USER_REMOVE_SUCCESS;
var TENANT_USER_REMOVE_ERROR = 'TENANT_USER_REMOVE_ERROR';
exports.TENANT_USER_REMOVE_ERROR = TENANT_USER_REMOVE_ERROR;
var TENANT_USER_UPDATE_REQUESTED = 'TENANT_USER_UPDATE_REQUESTED';
exports.TENANT_USER_UPDATE_REQUESTED = TENANT_USER_UPDATE_REQUESTED;
var TENANT_USER_UPDATE_SUCCESS = 'TENANT_USER_UPDATE_SUCCESS';
exports.TENANT_USER_UPDATE_SUCCESS = TENANT_USER_UPDATE_SUCCESS;
var TENANT_USER_UPDATE_ERROR = 'TENANT_USER_UPDATE_ERROR'; // Tenant User Requests

exports.TENANT_USER_UPDATE_ERROR = TENANT_USER_UPDATE_ERROR;
var TENANT_USER_REQUEST_UPDATE_REQUESTED = 'TENANT_USER_REQUEST_UPDATE_REQUESTED';
exports.TENANT_USER_REQUEST_UPDATE_REQUESTED = TENANT_USER_REQUEST_UPDATE_REQUESTED;
var TENANT_USER_REQUEST_UPDATE_SUCCESS = 'TENANT_USER_REQUEST_UPDATE_SUCCESS';
exports.TENANT_USER_REQUEST_UPDATE_SUCCESS = TENANT_USER_REQUEST_UPDATE_SUCCESS;
var TENANT_USER_REQUEST_UPDATE_ERROR = 'TENANT_USER_REQUEST_UPDATE_ERROR'; // Stripe data

exports.TENANT_USER_REQUEST_UPDATE_ERROR = TENANT_USER_REQUEST_UPDATE_ERROR;
var TENANT_STRIPE_CARD_REQUESTED = 'TENANT_STRIPE_CARD_REQUESTED';
exports.TENANT_STRIPE_CARD_REQUESTED = TENANT_STRIPE_CARD_REQUESTED;
var TENANT_STRIPE_CARD_SUCCESS = 'TENANT_STRIPE_CARD_SUCCESS';
exports.TENANT_STRIPE_CARD_SUCCESS = TENANT_STRIPE_CARD_SUCCESS;
var TENANT_STRIPE_CARD_ERROR = 'TENANT_STRIPE_CARD_ERROR';
exports.TENANT_STRIPE_CARD_ERROR = TENANT_STRIPE_CARD_ERROR;
var TENANT_STRIPE_INVOICES_REQUESTED = 'TENANT_STRIPE_INVOICES_REQUESTED';
exports.TENANT_STRIPE_INVOICES_REQUESTED = TENANT_STRIPE_INVOICES_REQUESTED;
var TENANT_STRIPE_INVOICES_SUCCESS = 'TENANT_STRIPE_INVOICES_SUCCESS';
exports.TENANT_STRIPE_INVOICES_SUCCESS = TENANT_STRIPE_INVOICES_SUCCESS;
var TENANT_STRIPE_INVOICES_ERROR = 'TENANT_STRIPE_INVOICES_ERROR';
exports.TENANT_STRIPE_INVOICES_ERROR = TENANT_STRIPE_INVOICES_ERROR;
var TENANT_STRIPE_PREVIEW_INVOICE_REQUESTED = 'TENANT_STRIPE_PREVIEW_INVOICE_REQUESTED';
exports.TENANT_STRIPE_PREVIEW_INVOICE_REQUESTED = TENANT_STRIPE_PREVIEW_INVOICE_REQUESTED;
var TENANT_STRIPE_PREVIEW_INVOICE_SUCCESS = 'TENANT_STRIPE_PREVIEW_INVOICE_SUCCESS';
exports.TENANT_STRIPE_PREVIEW_INVOICE_SUCCESS = TENANT_STRIPE_PREVIEW_INVOICE_SUCCESS;
var TENANT_STRIPE_PREVIEW_INVOICE_ERROR = 'TENANT_STRIPE_PREVIEW_INVOICE_ERROR';
exports.TENANT_STRIPE_PREVIEW_INVOICE_ERROR = TENANT_STRIPE_PREVIEW_INVOICE_ERROR;
var TENANT_STRIPE_UPCOMING_INVOICES_REQUESTED = 'TENANT_STRIPE_UPCOMING_INVOICES_REQUESTED';
exports.TENANT_STRIPE_UPCOMING_INVOICES_REQUESTED = TENANT_STRIPE_UPCOMING_INVOICES_REQUESTED;
var TENANT_STRIPE_UPCOMING_INVOICES_SUCCESS = 'TENANT_STRIPE_UPCOMING_INVOICES_SUCCESS';
exports.TENANT_STRIPE_UPCOMING_INVOICES_SUCCESS = TENANT_STRIPE_UPCOMING_INVOICES_SUCCESS;
var TENANT_STRIPE_UPCOMING_INVOICES_ERROR = 'TENANT_STRIPE_UPCOMING_INVOICES_ERROR';
exports.TENANT_STRIPE_UPCOMING_INVOICES_ERROR = TENANT_STRIPE_UPCOMING_INVOICES_ERROR;
var TENANT_STRIPE_UPDATE_CARD = 'TENANT_STRIPE_UPDATE_CARD';
exports.TENANT_STRIPE_UPDATE_CARD = TENANT_STRIPE_UPDATE_CARD;